<template>
  <div class="api-lookup-auth-section">
    <Loading
      :active.sync="isLoading"
      :background-color="loaderBackgroundColor"
      :color="loaderColor"
      :is-full-page="false"
      loader="dots"
    />
    <VasionTooltip :text="tooltipAPIAuthenticationsMessage" position="bottom">
      <div>
        <label class="vasion-input-label-top"> API Authentication </label
        ><span class="vasion-required-indicator">*</span>
      </div>
    </VasionTooltip>
    <VasionDropList
      v-model="formFields.apiAuthentication"
      v-slot="slotItem"
      :dataArray="lists.apiAuthentications"
      :required="true"
      :showIfEmpty="true"
      :showSearchField="true"
      @input="emitSectionIsDirty"
      displayName="name"
      type="plain-list"
      valueName="id"
      width="300"
    >
      {{ slotItem.item.name }}
    </VasionDropList>
  </div>
</template>
<script>
import Loading from 'vue-loading-overlay'
import { loaderBackgroundColor, loaderColor } from '@/assets/js/styleConfig'

export default {
  name: 'ApiLookupAuthFormSection',
  components: {
    Loading,
  },
  props: {
    apiAuthenticationTypeChanged: {
      type: Function,
      required: true,
    },
    configurationData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formFields: {
        apiAuthentication: '',
      },
      isLoading: false,
      lists: {
        apiAuthentications: [],
      },
      loaderBackgroundColor: loaderBackgroundColor,
      loaderColor: loaderColor,
      editableData: this.configurationData,
      tooltipAPIAuthenticationsMessage:
        'To use this API tool, you\'ll need an API account.  Go to the "Admin" section, then "Integrations," and finally "API Accounts." There you can click "Add Account" to create one.',
    }
  },
  watch: {
    configurationData: {
      immediate: true,
      handler(val) {
        this.editableData = val

        if (val && val?.ApiAuthenticationId >= 0) {
          this.setAuthenticationField(
            'apiAuthentication',
            this.lists.apiAuthentications,
            val.ApiAuthenticationId
          )
        }
      },
    },
    formFields: {
      deep: true,
      handler(val) {
        this.apiAuthenticationTypeChanged(val)
      },
    },
  },
  async created() {
    this.isLoading = true

    this.lists.apiAuthentications = await this.getApiAuthenticationsList()

    if (this.editableData && this.editableData?.ApiAuthenticationId >= 0) {
      this.setAuthenticationField(
        'apiAuthentication',
        this.lists.apiAuthentications,
        this.editableData.ApiAuthenticationId
      )
    }

    this.isLoading = false
  },
  methods: {
    async getApiAuthenticationsList() {
      let apiAuthenticationsList = []
      apiAuthenticationsList.push({
        id: 0,
        name: 'None',
      })

      const response = await this.$store.dispatch(
        'admin/getAllApiAuthentications'
      )
      if (response && response?.List) {
        response.List.map(apiAuthentication => {
          apiAuthenticationsList.push({
            id: apiAuthentication.id,
            name: apiAuthentication.name,
          })
        })
      }

      return apiAuthenticationsList
    },
    setAuthenticationField(fieldName, list, value) {
      this.formFields[fieldName] = list.find(item => item.id === value)
    },
    emitSectionIsDirty() {
      const payload = {
        section: 'auth',
        data: this.formFields,
      }
      this.$emit('markAsDirty', payload)
    },
  },
}
</script>
<style lang="scss" scoped>
.api-lookup-auth-section {
  padding: 8px;
}
</style>
